<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    color?: string;
    type?: 'default' | 'dot' | 'vertical';
  }

  const props = withDefaults(defineProps<Props>(), {
    color: '--border-divider',
    type: 'default',
  });

  const style = computed(() => {
    return {
      backgroundColor: `var(${props.color})`,
    };
  });
</script>

<template>
  <div
    :class="[
      'ui-separator',
      `ui-separator_${props.type}`
    ]"
    :style="style"
  />
</template>

<style lang="scss">
.ui-separator {
  width: 100%;
  height: 1px;
  &_vertical {
    width: 1px;
    align-self: stretch;
    height: auto;
  }
  &_dot {
    width: 4px;
    height: 4px;
    border-radius: 8px;
  }
}
</style>
